import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "overrides", "className", "options", "onChange", "onBlur", "value", "label", "labelMode", "hint", "error", "isReadOnly", "isFullWidth", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Label from '../Label';
import CheckboxControl from './CheckboxControl';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'CheckboxGroup');
function CheckboxGroup(_ref) {
  var _classnames;
  var children = _ref.children,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    options = _ref.options,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    value = _ref.value,
    label = _ref.label,
    labelMode = _ref.labelMode,
    hint = _ref.hint,
    error = _ref.error,
    isReadOnly = _ref.isReadOnly,
    isFullWidth = _ref.isFullWidth,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  // Overrides
  var override = getOverrides(overridesProp, CheckboxGroup.overrides);

  // Classes
  var rootClassName = classnames(classes.root, (_classnames = {}, _defineProperty(_classnames, classes.isReadOnly, isReadOnly === true), _defineProperty(_classnames, classes[labelMode], labelMode), _defineProperty(_classnames, classes.errored, error), _classnames), classNameProp);
  var formControlClassName = classnames(classes.formControl, _defineProperty({}, classes.isFullWidth, isFullWidth));
  var rootProps = {
    className: rootClassName
  };
  var labelProps = _objectSpread({
    className: classnames(classes.Label, _defineProperty({}, classes.isFullWidth, isFullWidth)),
    hint: hint
  }, override.Label);
  var onChangeCheckbox = useCallback(function (option) {
    onChange && onChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, option, !value[option])));
    onBlur && onBlur(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, option, !value[option])));
  }, [onBlur, onChange, value]);
  var hasErrorObj = useMemo(function () {
    return !error || _typeof(error) !== 'object' ? false : Object.entries(error).length > 0;
  }, [error]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), label && /*#__PURE__*/React.createElement(Label, labelProps, label), /*#__PURE__*/React.createElement("div", _extends({
    className: formControlClassName
  }, override.formControl), options.map(function (option, i) {
    return /*#__PURE__*/React.createElement(CheckboxControl, {
      key: option.value,
      option: option,
      value: value[option.value],
      isReadOnly: Array.isArray(isReadOnly) ? isReadOnly[i] : isReadOnly,
      onChange: onChangeCheckbox,
      color: color,
      overrides: overridesProp,
      error: hasErrorObj ? error[option.value] : undefined
    });
  }), error && !hasErrorObj && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.error
  }, override.error), error)));
}
CheckboxGroup.overrides = ['root', 'error', 'Checkbox', 'checkboxLabel', 'checkboxControl', 'formControl', 'Label'];
CheckboxGroup.defaultProps = {
  labelMode: 'horizontal',
  onChange: function onChange() {},
  value: {},
  options: [],
  isReadOnly: false,
  overrides: {}
};
process.env.NODE_ENV !== "production" ? CheckboxGroup.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  value: PropTypes.object,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  label: PropTypes.string,
  labelMode: PropTypes.oneOf(['horizontal', 'vertical']),
  /** Info popover */
  hint: PropTypes.string,
  isReadOnly: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  isFullWidth: PropTypes.bool
} : void 0;
export default /*#__PURE__*/React.memo(CheckboxGroup);